import React, { useContext, useMemo, useState, useEffect } from "react";
import { EditClient } from "./components/editClient/EditClient";
import { CalendarGrid } from "../../components/calendarGrid/CalendarGrid";
import { Spinner } from "../../components/spinner/Spinner";
import { DialogueTree } from "./components/dialogueTree/DialogueTree";
import { FullAnalysis } from "./components/fullAnalysis/FullAnalysis";
import { Lifeline } from "./components/lifeline/Lifeline";
import { Notes } from "./components/notes/Notes";
import { TreatmentPlan } from "./components/treatmentPlan/TreatmentPlan";
import { DashboardContext } from "./DashboardContext";
import { AppContext } from "../../appContext";
import { setTimezoneAwareHours } from "../../utils/dateFormats";
import { Mindmap } from "../desktopPage/Mindmap";
import { FullSessions } from "./components/sessions/FullSessions";
import { Chat } from "../../components/chat/Chat";
import { chatMessages } from "../../mocks/meetingPage";
import { TasksView } from "./components/tasks/TasksView";
import { StatisticPage } from "./components/statisticPage/StatisticPage";

export const DashboardClientPopupRouter = () => {
    const dashboardContext = useContext(DashboardContext);
    const {
        editClientId, setEditClientId,
        selectedClient,
        activePopup, setActivePopup,
        editClient,
        deleteClient: _deleteClient,
        setSelectedLeftMenuTabIndex,
        isDashboardVisible
    } = dashboardContext;

    const contextData = useContext(AppContext);
    const clientsData = contextData.clients || [];

    // Track the previous popup before opening EditClient
    const [previousPopup, setPreviousPopup] = useState<string>('');
    const previousPopupRef = React.useRef<string>('');

    // Track previous popup when EditClient is opened
    useEffect(() => {
        if (activePopup !== 'EditClient' && activePopup !== '') {
            // Store the current popup in case EditClient is opened next
            previousPopupRef.current = activePopup;
        } else if (activePopup === 'EditClient') {
            // Save the previous popup when EditClient is opened
            setPreviousPopup(previousPopupRef.current);
        }
    }, [activePopup]);

    // Switch to Schedule tab when client calendar is opened
    useEffect(() => {
        if (activePopup === 'Calendar') {
            setSelectedLeftMenuTabIndex(1); // Switch to Schedule tab (index 1)
        }
    }, [activePopup, setSelectedLeftMenuTabIndex]);

    return <div className={`under_layer ${isDashboardVisible ? 'under_layer--hidden' : ''}`}>
        {
            activePopup == 'EditClient' && <EditClient
                client={selectedClient}
                onClose={() => {
                    // Restore previous popup if there was one
                    if (previousPopup && previousPopup !== '') {
                        setActivePopup(previousPopup);
                        setPreviousPopup('');
                    } else {
                        setActivePopup('');
                    }
                    setEditClientId(null);
                }}
                onSave={(data) => {
                    editClient(data);
                }}
                onDelete={(clientId) => {
                    _deleteClient(clientId)
                }}
                onSaveDraft={() => { }}
            ></EditClient>
        }
        {activePopup == 'FullSessionList' && <FullSessions></FullSessions>}
        {activePopup == 'FullAnalysis' && <FullAnalysis
            onClose={() => setActivePopup('')}
        ></FullAnalysis>}
        {activePopup == 'TreatmentPlan' && <TreatmentPlan
            onClose={() => setActivePopup('')}
        ></TreatmentPlan>}
        {activePopup == 'DialogueTree' && <DialogueTree
            onClose={() => setActivePopup('')}
        ></DialogueTree>}
        {activePopup == 'Lifeline' && <Lifeline
            onClose={() => setActivePopup('')}
        ></Lifeline>}
        {activePopup == 'Mindmap' && <Mindmap
        ></Mindmap>}
        {(activePopup == 'Calendar') && ((selectedClient.sessions) ? <CalendarGrid
            tickets={selectedClient.sessions.map(session => {
                const startDate = new Date(session.date);
                let endDate = new Date(session.dateTo);
                if (!session.dateTo || Number.isNaN(endDate.valueOf())) {
                    const startDateObj = new Date(session.date);
                    const endHour = new Date(startDateObj).getHours() + 1;
                    endDate = setTimezoneAwareHours(startDateObj, endHour); //default one hour if not end date
                }
                return {
                    start: startDate,
                    end: endDate,
                    title: session.title,
                    type: 'session',
                    original: session
                }
            })}
        ></CalendarGrid> : <div style={{ padding: "16px 22px" }}> <Spinner></Spinner></div>)}
        {activePopup == 'Chat' && <div>
            Chat is in development
            <Chat messages={chatMessages}></Chat>
        </div>}
        {activePopup == 'Tasks' && <TasksView key={`tasks-${Date.now()}`} />}
        {activePopup == 'Notes' && <Notes />}
        {activePopup == 'Statistic' && <StatisticPage />}
    </div>
}